import { jsx as n, jsxs as v } from "react/jsx-runtime";
import c from "react";
import './index.css';function N(r) {
  var a, l, o = "";
  if (typeof r == "string" || typeof r == "number") o += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var e = r.length;
    for (a = 0; a < e; a++) r[a] && (l = N(r[a])) && (o && (o += " "), o += l);
  } else for (l in r) r[l] && (o && (o += " "), o += l);
  return o;
}
function d() {
  for (var r, a, l = 0, o = "", e = arguments.length; l < e; l++) (r = arguments[l]) && (a = N(r)) && (o && (o += " "), o += a);
  return o;
}
const z = (r) => typeof r == "boolean" ? `${r}` : r === 0 ? "0" : r, x = d, R = (r, a) => (l) => {
  var o;
  if ((a == null ? void 0 : a.variants) == null) return x(r, l == null ? void 0 : l.class, l == null ? void 0 : l.className);
  const { variants: e, defaultVariants: s } = a, i = Object.keys(e).map((w) => {
    const m = l == null ? void 0 : l[w], u = s == null ? void 0 : s[w];
    if (m === null) return null;
    const p = z(m) || z(u);
    return e[w][p];
  }), t = l && Object.entries(l).reduce((w, m) => {
    let [u, p] = m;
    return p === void 0 || (w[u] = p), w;
  }, {}), b = a == null || (o = a.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((w, m) => {
    let { class: u, className: p, ..._ } = m;
    return Object.entries(_).every((C) => {
      let [y, g] = C;
      return Array.isArray(g) ? g.includes({
        ...s,
        ...t
      }[y]) : {
        ...s,
        ...t
      }[y] === g;
    }) ? [
      ...w,
      u,
      p
    ] : w;
  }, []);
  return x(r, i, b, l == null ? void 0 : l.class, l == null ? void 0 : l.className);
}, M = "_icon_1r3wb_1", f = {
  icon: M,
  "size--xxsm": "_size--xxsm_1r3wb_5",
  "size--xsm": "_size--xsm_1r3wb_10",
  "size--sm": "_size--sm_1r3wb_15",
  "size--md": "_size--md_1r3wb_20",
  "size--lg": "_size--lg_1r3wb_25",
  "size--xlg": "_size--xlg_1r3wb_30",
  "size--xxlg": "_size--xxlg_1r3wb_35",
  "size--xxxlg": "_size--xxxlg_1r3wb_40",
  "color--black": "_color--black_1r3wb_45",
  "color--white": "_color--white_1r3wb_49",
  "color--green": "_color--green_1r3wb_53",
  "color--blue": "_color--blue_1r3wb_57",
  "color--grey": "_color--grey_1r3wb_61"
}, h = R(f.icon, {
  variants: {
    color: {
      black: f["color--black"],
      white: f["color--white"],
      blue: f["color--blue"],
      green: f["color--green"],
      grey: f["color--grey"]
    },
    size: {
      xxsm: f["size--xxsm"],
      xsm: f["size--xsm"],
      sm: f["size--sm"],
      md: f["size--md"],
      lg: f["size--lg"],
      xlg: f["size--xlg"],
      xxlg: f["size--xxlg"],
      xxxlg: f["size--xxxlg"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "sm"
  }
}), B = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 11, fill: "none", viewBox: "0 0 12 11", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "m.136 5.702 4.091 4.772c.178.249.546.248.773.045a.56.56 0 0 0 .045-.781L1.747 5.895h9.707c.301 0 .546-.251.546-.561s-.244-.561-.546-.561H1.747L5.045.93c.216-.215.156-.584-.071-.788s-.569-.189-.747.051L.136 4.965A.56.56 0 0 0 0 5.334c.01.119.059.279.136.368",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
B.displayName = "Arrow";
const E = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M16.5 1.838v14.999a.46.46 0 0 1-.248.413l-.18.046a.45.45 0 0 1-.316-.115l-1.735-1.631-.225.207v3.767a.46.46 0 0 1-.271.413l-.18.046a.45.45 0 0 1-.316-.115l-1.713-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.78-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.758-1.631-1.735 1.631a.44.44 0 0 1-.487.097.46.46 0 0 1-.279-.418V4.548c0-1.015.807-1.838 1.803-1.838h.901v-.873C3.204.823 4.011 0 5.007 0h9.69c.996 0 1.803.823 1.803 1.838m-4.868 15.458 1.262 1.195V4.525a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v13.966l1.284-1.195a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.444.444 0 0 1 .609 0zm2.682-2.71 1.284 1.194-.023-13.943a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v.85h7.887c.996 0 1.803.823 1.803 1.838v9.992a.445.445 0 0 1 .541.069M4.976 8h3.048c.263 0 .476-.224.476-.5S8.287 7 8.024 7H4.976c-.263 0-.476.224-.476.5s.213.5.476.5m-.06 2h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0 3h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5z",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
E.displayName = "Betslip";
const k = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ v("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: s, ...e, children: [
      /* @__PURE__ */ n(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
        }
      ),
      /* @__PURE__ */ n(
        "path",
        {
          fill: "currentColor",
          d: "m15.97 8.47-5.47 5.47-2.47-2.47a.75.75 0 1 0-1.06 1.06l3 3a.747.747 0 0 0 1.06 0l6-6a.75.75 0 1 0-1.06-1.06"
        }
      )
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
k.displayName = "CheckCircle";
const H = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 9, fill: "none", viewBox: "0 0 13 9", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
H.displayName = "ChevronDown";
const A = c.forwardRef(
  ({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
    const i = d(
      h({
        color: r,
        size: a
      }),
      o
    ), t = {
      "--opacity": l
    };
    return c.cloneElement(
      /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: s, ...e, children: /* @__PURE__ */ v("g", { fill: "currentColor", children: [
        /* @__PURE__ */ n("path", { d: "M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" }),
        /* @__PURE__ */ n("path", { d: "M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" })
      ] }) }),
      {
        role: "presentation",
        focusable: !1,
        className: i,
        "aria-hidden": !0,
        style: t,
        ...e
      }
    );
  }
);
A.displayName = "ChevronDownLight";
const L = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 8, fill: "none", viewBox: "0 0 13 8", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
L.displayName = "ChevronUp";
const V = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.778 19.778H4.222V4.222h6.667a1.11 1.11 0 1 0 0-2.222H4.222C2.99 2 2 3 2 4.222v15.556C2 21 2.989 22 4.222 22h15.556C21 22 22 21 22 19.778V13.11a1.11 1.11 0 1 0-2.222 0zM14.222 3.11c0 .614.498 1.111 1.111 1.111h2.878L8.072 14.362a1.108 1.108 0 0 0 1.567 1.566l10.139-10.14v2.879a1.11 1.11 0 0 0 2.222 0V4a2 2 0 0 0-2-2h-4.667a1.11 1.11 0 0 0-1.11 1.111z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
V.displayName = "Clickout";
const j = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ v("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none", viewBox: "0 0 13 13", ref: s, ...e, children: [
      /* @__PURE__ */ n("path", { fill: "currentColor", d: "M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" }),
      /* @__PURE__ */ n("path", { fill: "currentColor", d: "M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
j.displayName = "Cross";
const S = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M15.344 17.778a.75.75 0 0 0-.75-.75h-5.16a.75.75 0 1 0 0 1.5h5.16a.75.75 0 0 0 .75-.75m2.206-4a.75.75 0 0 0-.75-.75H7.204a.75.75 0 1 0 0 1.5H16.8a.75.75 0 0 0 .75-.75m2.45-4a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 .75-.75m2-4a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h18.5a.75.75 0 0 0 .75-.75"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
S.displayName = "Filter";
const O = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", viewBox: "0 0 15 15", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 13.5a6 6 0 0 0 4.243-1.757A6 6 0 0 0 13.5 7.5a6 6 0 0 0-1.757-4.243A6 6 0 0 0 7.5 1.5a6 6 0 0 0-6 6 6 6 0 0 0 6 6m0 1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3h1.5v1.5h-1.5z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
O.displayName = "Info";
const Z = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M1.423 0a.923.923 0 1 0 0 1.846h14.154a.923.923 0 1 0 0-1.846zM.5 7.692c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423A.923.923 0 0 1 .5 7.692m0 6.769c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423a.923.923 0 0 1-.923-.923",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
Z.displayName = "Menu";
const D = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ v(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 19 18",
        ref: s,
        ...e,
        children: [
          /* @__PURE__ */ n("path", { d: "m6.361 11.888.359-.84a.4.4 0 0 1 .229-.222.4.4 0 0 1 .125-.022q.098 0 .185.049c.546.306 1.279.49 1.961.49.801 0 1.383-.345 1.383-.818 0-.306-.169-.676-1.415-1.102-1.35-.446-2.725-1.097-2.725-2.557 0-1.108.767-1.975 2.052-2.317l.195-.052v-.916c0-.224.177-.408.39-.408h.923a.4.4 0 0 1 .39.408v.823l.229.03a4.6 4.6 0 0 1 1.482.432c.094.047.166.129.2.232s.031.216-.013.312l-.372.829a.39.39 0 0 1-.354.235.4.4 0 0 1-.161-.038c-.242-.118-.809-.388-1.714-.388-.822 0-1.188.334-1.188.667 0 .372.382.624 1.578 1.039 1.274.438 2.575 1.097 2.575 2.683 0 .856-.564 2.008-2.156 2.429l-.195.055v.949c0 .227-.177.41-.39.41h-.939a.4.4 0 0 1-.39-.41V13l-.231-.025c-.718-.085-1.394-.29-1.849-.566a.42.42 0 0 1-.163-.522z" }),
          /* @__PURE__ */ n(
            "path",
            {
              d: "M18.228 8.727a8.73 8.73 0 0 1-8.727 8.727A8.73 8.73 0 0 1 .773 8.727 8.73 8.73 0 0 1 9.501 0a8.73 8.73 0 0 1 8.727 8.727m-1.091 0c0 4.382-3.255 7.636-7.636 7.636s-7.636-3.255-7.636-7.636S5.12 1.091 9.501 1.091s7.636 3.255 7.636 7.636",
              fillRule: "evenodd"
            }
          )
        ]
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
D.displayName = "Offers";
const P = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ v("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: s, ...e, children: [
      /* @__PURE__ */ n(
        "path",
        {
          stroke: "currentColor",
          d: "M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
        }
      ),
      /* @__PURE__ */ n("path", { stroke: "currentColor", d: "M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
P.displayName = "Padlock";
const F = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 20, fill: "none", viewBox: "0 0 12 20", ref: s, ...e, children: /* @__PURE__ */ n("path", { stroke: "currentColor", d: "M4.9 11.119H1L8.8 1 6.85 8.738h3.9l-7.8 10.119z", strokeLinejoin: "round" }) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
F.displayName = "Picks";
const I = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", viewBox: "0 0 19 19", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        fill: "currentColor",
        d: "M9.048.949a.5.5 0 0 1 .903 0l2.45 5.151a.5.5 0 0 0 .387.281l5.656.738a.5.5 0 0 1 .279.859L14.581 11.9a.5.5 0 0 0-.148.455l1.046 5.607a.5.5 0 0 1-.731.531l-5.009-2.727a.5.5 0 0 0-.478 0l-5.009 2.727a.5.5 0 0 1-.731-.531l1.046-5.607a.5.5 0 0 0-.148-.455L.277 7.978a.5.5 0 0 1 .279-.859l5.656-.738a.5.5 0 0 0 .387-.281z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
I.displayName = "Star";
const U = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 20, fill: "none", viewBox: "0 0 22 20", ref: s, ...e, children: /* @__PURE__ */ n(
      "path",
      {
        stroke: "currentColor",
        d: "M15.965 4.968c0 2.372-2.081 4.368-4.743 4.368S6.478 7.34 6.478 4.968 8.56.6 11.222.6s4.743 1.996 4.743 4.368ZM15.318 10.857c.174-.116.314-.182.435-.205 1.448-.273 2.575.594 3.49 2.15.906 1.543 1.472 3.573 1.799 5.122.16.758-.429 1.476-1.275 1.476H1.863c-.75 0-1.265-.556-1.207-1.185.222-2.425 1.23-6.34 5.288-7.684.275-.091.607-.059.935.095 1.852.867 3.42 1.291 4.805 1.31 1.4.02 2.577-.374 3.634-1.079Z",
        strokeWidth: 1.2
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
U.displayName = "Account";
const W = c.forwardRef(({ color: r, size: a, opacity: l = 1, className: o, ...e }, s) => {
  const i = d(
    h({
      color: r,
      size: a
    }),
    o
  ), t = {
    "--opacity": l
  };
  return c.cloneElement(
    /* @__PURE__ */ n(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.78,
        height: 9.58,
        fill: "none",
        viewBox: "0 0 12.78 9.58",
        ref: s,
        ...e,
        children: /* @__PURE__ */ n("path", { fill: "currentColor", d: "m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" })
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: t,
      ...e
    }
  );
});
W.displayName = "Check";
export {
  H as A,
  P as D,
  A as E,
  V as H,
  k as I,
  j as L,
  O as S,
  L as V,
  W
};
